import Splide from '@splidejs/splide';

(() => {
    const blocks = document.querySelectorAll('[data-anchor-thumb-slider]');

    const options = {
        type: 'fade',
        rewind: true,
        pagination: false,
        lazyLoad: 'nearby',
        preloadPages: 0,
    };
    const thumbOptions = {
        rewind: true,
        perPage: 5,
        isNavigation: true,
        lazyLoad: 'nearby',
        preloadPages: 0,
        gap: '6px',
        pagination: false,
        arrows: false,
        mediaQuery: 'min',
        breakpoints: {
            768: {
                direction: 'ttb',
                heightRatio: 5.8,
                gap: '10px',
                arrows: true,
                perMove: 1,
            },
        },
    };

    for (let block of blocks) {
        const main = new Splide(block.querySelector('.splide-thumb-mid'), options);
        const thumbnails = new Splide(block.querySelector('.splide-thumb-mid-thumbs'), thumbOptions);

        main.sync(thumbnails);
        main.mount();
        thumbnails.mount();
    }
})();
